import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=50024288&scoped=true"
import script from "./Searchbar.vue?vue&type=script&lang=ts"
export * from "./Searchbar.vue?vue&type=script&lang=ts"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=50024288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50024288",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/skade-pwa/components/ui/atom/Icon.vue').default,Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
